import { createTheme } from "@mui/material/styles";

/** Dark chrome: the nav bar and its buttons. */
const CHROME = "#2f2f2f";
/**
 * The colour for the one main action on a screen (Approve, Propose, Next Day, Save).
 * White text on it is 5.1:1. Everything secondary stays an outlined grey button.
 */
export const ACTION = "#2e7d32";
const ACTION_HOVER = "#1b5e20";
/** The accent already used on cards; also marks the current page in the nav. */
export const ACCENT = "#fb8c00";

let theme = createTheme({
  palette: {
    primary: {
      main: CHROME,
    },
    background: {
      default: "#f5f5f5", // Light grey background
    },
    // The default info blue is 3.9:1 against white text; this is 5:1.
    info: {
      main: "#0277bd",
    },
    // The default warning orange is 3.1:1 on white (buttons, chips); this is 4.6:1.
    warning: {
      main: "#b85c00",
    },
  },
  components: {
    MuiTypography: {
      defaultProps: {
        // MUI renders subtitle1/subtitle2 as <h6>, which turned every label into a heading.
        // Real headings say so with component="h2" etc.
        variantMapping: { subtitle1: "p", subtitle2: "p" },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: "none", // Normal casing on buttons
        },
      },
      variants: [
        // Main actions are contained buttons, and they get the action colour.
        {
          props: { variant: "contained", color: "primary" },
          style: {
            backgroundColor: ACTION,
            "&:hover": { backgroundColor: ACTION_HOVER },
          },
        },
      ],
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          // The nav bar's own buttons are "contained primary" too; keep them dark, not green.
          "& .MuiButton-contained.MuiButton-colorPrimary": {
            backgroundColor: CHROME,
            "&:hover": { backgroundColor: "#424242" },
          },
        },
      },
    },
  },
});

theme = createTheme(theme, {
  // Custom colors created with augmentColor go here
  palette: {
    bland: theme.palette.augmentColor({
      color: {
        main: CHROME,
      },
      name: "bland",
    }),
  },
});

export default theme;
